import { Plane } from "lucide-react";

// Airplane crest logo — a jet inside a golden compass ring
export const AirplaneLogo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="46" fill="none" stroke="#D4AF37" strokeWidth="2" />
    <circle cx="50" cy="50" r="38" fill="none" stroke="#D4AF37" strokeWidth="0.8" strokeDasharray="2 3" />
    <line x1="50" y1="6" x2="50" y2="16" stroke="#D4AF37" strokeWidth="1.5" />
    <line x1="50" y1="84" x2="50" y2="94" stroke="#D4AF37" strokeWidth="1.5" />
    <line x1="6" y1="50" x2="16" y2="50" stroke="#D4AF37" strokeWidth="1.5" />
    <line x1="84" y1="50" x2="94" y2="50" stroke="#D4AF37" strokeWidth="1.5" />
    <path
      d="M50 26 L57 58 L72 68 L57 66 L54 78 L50 72 L46 78 L43 66 L28 68 L43 58 Z"
      fill="#D4AF37"
    />
  </svg>
);

// Brand emblem — uses the active PRIYARAA logo from brand settings (falls back to uploaded default)
export const BrandMark = ({ className = "", size = 58, src = "/priyaraa-logo.png" }) => (
  <div className={`flex items-center ${className}`}>
    <img
      src={src || "/priyaraa-logo.png"}
      alt="PRIYARAA Jewellery — For Your Story"
      style={{ width: size, height: size }}
      className="rounded-full bg-[#FAF7F2] object-contain"
    />
  </div>
);

// Passport-style stamp badge for product cards
export const PassportStamp = ({ label, className = "" }) => (
  <div
    className={`select-none rotate-[-8deg] rounded-md border-2 border-dashed border-amber-700/70 px-2 py-1 ${className}`}
    style={{ backgroundColor: "rgba(250,247,242,0.85)" }}
  >
    <span className="font-mono text-[9px] font-semibold uppercase tracking-widest text-amber-800">
      {label}
    </span>
  </div>
);

// Curved dashed flight-path divider with a plane
export const FlightPathDivider = ({ className = "" }) => (
  <div className={`relative flex items-center justify-center py-2 ${className}`}>
    <svg viewBox="0 0 600 40" className="w-full max-w-3xl" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M10 30 Q 300 -10 590 30"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="1.2"
        strokeDasharray="3 5"
      />
      <circle cx="10" cy="30" r="3" fill="#D4AF37" />
      <circle cx="590" cy="30" r="3" fill="#D4AF37" />
    </svg>
    <Plane className="absolute text-amber-600 animate-float" size={22} style={{ transform: "rotate(12deg)" }} />
  </div>
);
